module.exports = __webpack_public_path__ + "media/dashboard/assets/images/berrysupport-onboard-agents-3aa5083668cda00c9c618256b8ede720.svg";